var _circle, _path, _path2, _path3, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyStateBellHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.891,
    cy: 27,
    r: 26.916,
    fill: "#F8F9FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.695 34.563H30.71v-2.291h12.295a.936.936 0 00.677-.286.933.933 0 00.266-.685 16 16 0 00-1.407-6.11 16.114 16.114 0 00-3.49-4.973 16.093 16.093 0 00-9.775-4.498v-2.479c0-.136.111-.247.248-.247.317 0 .615-.123.84-.348.223-.224.346-.52.346-.837v-.624c0-.654-.532-1.185-1.186-1.185H26.03c-.655 0-1.187.531-1.187 1.185v.624c0 .653.532 1.185 1.187 1.185a.248.248 0 01.247.247v2.48a16.092 16.092 0 00-9.774 4.497 16.113 16.113 0 00-3.491 4.972 16.008 16.008 0 00-1.406 6.111c-.008.257.086.5.265.685.18.184.42.286.677.286h12.295v2.29H13.861a2.255 2.255 0 00-2.255 2.252v4.451h32.343v-4.452a2.255 2.255 0 00-2.254-2.25z",
    fill: "#E3E7F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.606 31.851c0-8.945 7.252-16.197 16.197-16.197S44 22.906 44 31.851v.417H11.606v-.417z",
    fill: "#D2D7E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.471 26.235a3.235 3.235 0 11-6.47 0h.713a2.521 2.521 0 105.044 0h.713z",
    fill: "#A9B2CF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 2,
    fill: "#A9B2CF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 22,
    r: 2,
    fill: "#A9B2CF"
  })));
}

export default SvgEmptyStateBellHappy;